import { useContext, useState } from 'react';

import DailyView from './components/DailyView';

import globalContext from '../../context/GlobalContext';

import {
  ADD_FAB_BUTTON, ADD_FAB_ICON
} from '../../utilities/generatedClasses';
import Icon from '../../components/Icon';
import Error from '../../components/Error';
import { checkAccess } from '../../utilities/userAccess';
import CalendarDialog from '../Dashboard/components/CalendarDialog';
import { unOverlayTopSide } from '../../utilities/utils';

import { useNavigate, useSearchParams } from 'react-router-dom';

const Recommendations = () => {
  const context = useContext(globalContext);
  const navigate = useNavigate();
   const [searchParams] = useSearchParams();
    
    const clientId = searchParams.get("clientid");

   const showAddRecommendatationPopup = () => {
    navigate('/home/recommendations/add' + (clientId ? `?clientid=${clientId}` : ''));
  };
  const [open, setOpen] = useState(false);

  const handleClose = (value) => {
    unOverlayTopSide();
    setOpen(false);
  };

  return (
    checkAccess('2')

      ? (
        <div className="recommendation-grid">
          <DailyView clientId={clientId}/>
          <div className="bottom-actions">
                 
            <label className={`fab-btn add-recommendation-fab-btn ${ADD_FAB_BUTTON}`} onClick={showAddRecommendatationPopup} aria-hidden="true">
              <Icon classNames={`small_size ${ADD_FAB_ICON}`} />
            </label>

         
          </div>
          {/* <CalendarDialog open={open} onClose={handleClose} /> */}
        </div>
      )
      : <Error line1="Acces Denied" line2="" line3="" />

  );
};

export default Recommendations;
